import { Component, inject } from '@angular/core';
import { ExtendedDynamoFormControl } from '../dynamic-form/dynamic-form.component';
import { DynamoFormControl, DynamoFormControlType, DynamoHttpService } from '@skillgmbh/dynamo';
import { FormControl } from '@ngneat/reactive-forms';
import { Validators } from '@angular/forms';
import { SuggestionFormData } from '../../lib/interfaces/SuggestionFormData';
import { MimeMessage } from '../../lib/interfaces/MimeMessage';
import { environment } from '../../../environments/environment';
import { take, timer } from 'rxjs';
import { OverlayService } from '../../services/overlay/overlay.service';

@Component({
    selector: 'app-suggestion-form',
    templateUrl: './suggestion-form.component.html',
    styleUrl: './suggestion-form.component.scss',
})
export class SuggestionFormComponent {
    protected formModel: ExtendedDynamoFormControl[] = [];
    protected formTextArea: DynamoFormControl = {
        name: 'additionalInfo',
        control: new FormControl(''),
        formControlType: DynamoFormControlType.INPUT,
        selectPlaceholder: 'Schreibe uns weitere Informationen, falls wir noch etwas wissen sollten :)',
    };
    protected requestSuccessful: boolean = false;

    private dynamoHttpService: DynamoHttpService = inject(DynamoHttpService);
    private overlayService: OverlayService = inject(OverlayService);

    constructor() {
        this.formModel = this.defaultFormModel;
    }

    private get defaultFormModel(): ExtendedDynamoFormControl[] {
        return [
            {
                name: 'name',
                control: new FormControl('', [Validators.required, Validators.minLength(2)]),
                formControlType: DynamoFormControlType.INPUT,
                labelText: 'Name des Restaurants *',
                full: true,
            },
            {
                name: 'city',
                control: new FormControl('', [Validators.required, Validators.minLength(2)]),
                formControlType: DynamoFormControlType.INPUT,
                labelText: 'Stadt *',
                full: true,
            },
        ];
    }

    protected submit(formGroupData: FormData): void {
        this.dynamoHttpService
            .post<unknown>('mail', 'email', 'send', this.MimeMessage(formGroupData as SuggestionFormData))
            .subscribe((): void => {
                this.requestSuccessful = true;

                timer(5000)
                    .pipe(take(1))
                    .subscribe((): void => {
                        this.overlayService.close();
                    });
            });
    }

    MimeMessage(suggestionFormData: SuggestionFormData): MimeMessage {
        return {
            subject: 'MyMeal Restaurant Suggestion',
            receiver: environment.suggestions_email,
            content:
                `Name: ${suggestionFormData.name}<br><br>` +
                `City: ${suggestionFormData.city}<br><br>` +
                `Additional information: ${suggestionFormData.additionalInfo}<br><br>`,
            priority: 1,
            html: true,
        } as MimeMessage;
    }
}
